// extracted by mini-css-extract-plugin
module.exports = {"header":"header__1lLOD","nav":"nav__1AOMm","active":"active__3WHjY","padding":"padding__3vguP"};